import person from "../../assets/imgs/persons/confusedMale.png";
import { useTheme } from "@mui/material";
export default function ConfusedMaleNoBack({
	mainFill,
	primaryCircleFill,
	highlightTitle,
	subtitle,
	highlightSubtitle,
}) {
	const theme = useTheme();
	return (
		<div style={{ width: "100%", maxWidth: "700px", margin: "0 auto" }}>
			<svg
				width="629"
				height="509"
				viewBox="0 0 629 509"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				style={{ width: "100%", height: "auto", display: "block" }}
			>
				<circle cx="444" cy="365.489" r="100" fill={primaryCircleFill} />
				<rect
					x="232"
					y="201.489"
					width="394"
					height="264"
					fill="url(#pattern0_998_3304)"
				/>

				{/* TEXTO DENTRO DO SVG */}
				<text
					x="80"
					y="200"
					fill={theme.palette.primary.main}
					fontWeight="700"
					fontSize="36"
				>
					{highlightTitle}
				</text>
				<text
					x="80"
					y="235"
					fill={theme.palette.text.main}
					fontWeight="400"
					fontSize="24"
				>
					{subtitle?.split("\n").map((line, i) => (
						<tspan key={i} x="80" dy={i === 0 ? 0 : 24}>
							{line}
						</tspan>
					))}
				</text>
				<text
					x="158"
					y="283"
					fill={theme.palette.primary.main}
					fontWeight="700"
					fontSize="22"
				>
					{highlightSubtitle}
				</text>

				<defs>
					<pattern
						id="pattern0_998_3304"
						patternContentUnits="objectBoundingBox"
						width="1"
						height="1"
					>
						<use
							xlinkHref="#image0_998_3304"
							transform="matrix(0.000656825 0 0 0.000980262 -0.000634518 0)"
						/>
					</pattern>
					<image
						id="image0_998_3304"
						width="1536"
						height="1024"
						preserveAspectRatio="none"
						href={person}
					/>
				</defs>
			</svg>
		</div>
	);
}
